<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { Icon } from "../../components";
import { getPrice, showDurationUnit } from "../../utilities";
import useChatWidget from "../stores/chatWidget";

const $chatWidget = useChatWidget();
const $globalSetting = computed(() => $chatWidget.getGlobalSettings());
const $config = $chatWidget.getConfig;
const $setting = $chatWidget.getSettings;
const $services = computed(() => $chatWidget.getServices());
const $payload = $chatWidget.getPayload();
const selectedService = ref(null);
const showContent = ref(true);

onMounted(async () => {
  if ($services.value.length === 0) {
    await $chatWidget.fetchServices();
  }
  // setTimeout(() => {
  //   showContent.value = true;
  // }, 149);
});

watch(
  () => $payload.value?.staff,
  (newStaff) => {
    if (newStaff) {
      selectedService.value = null;
    }
  },
  { deep: true }
);

const handleService = (service) => {
  selectedService.value = service;

  const tempPayload = $payload;
  tempPayload.service = service;
  tempPayload.step = $payload.step + 1;
  $chatWidget.updatePayload(tempPayload);
};
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div id="prebook-chat-component-service" class="px-4 py-[15px]">
      <div class="inline-flex w-[50px]">
        <img
          :src="$globalSetting?.settings?.business?.full_logo_url"
          :alt="$globalSetting?.settings?.business?.name"
          class="w-full object-contain"
        />
      </div>
      <h2 class="text-[20px]">
        {{ $setting.service.question }}
      </h2>
      <div class="flex flex-col gap-2.5 py-[10px]">
        <div
          v-for="service in $services"
          :key="service.service_id"
          :class="{
            active:
              selectedService &&
              selectedService.service_id === service.service_id,
          }"
          class="group transition delay-150 duration-300 ease-in-out hover:bg-gray-200 flex items-center justify-between gap-1.5 border-solid border-[1.5px] border-gray-200 rounded-[8px] p-[12px]"
        >
          <div class="flex items-center gap-2">
            <div
              class="w-[60px] h-[60px] flex items-center justify-center rounded-[6px] flex-shrink-0"
              :style="{
                'background-color': service.color,
              }"
            >
              <img
                v-if="service.thumbnail_image_url"
                :src="service.thumbnail_image_url"
                :alt="service.name"
                class="w-[60px] h-[60px] object-cover rounded-[6px] border-2 border-white"
              />
              <span
                v-else
                class="inline-flex text-[20px] text-white font-medium"
              >
                {{ service.name.substring(0, 1).toUpperCase() }}
              </span>
            </div>
            <div class="">
              <h3 class="font-medium text-[16px] m-0">{{ service.name }}</h3>
              <p class="text-[14px] text-gray-500 mt-2 mb-0">
                {{ getPrice(service.price) }}
              </p>
            </div>
          </div>
          <div class="flex items-center gap-1.5">
            <p class="text-[14px] whitespace-nowrap">
              {{ showDurationUnit(service.duration, service.duration_unit) }}
            </p>
            <button
              @click="handleService(service)"
              class="add-service w-[34px] h-[34px] flex items-center justify-center cursor-pointer bg-gray-200 rounded-[28px]"
            >
              <Icon name="plus" class="text-gray-500 w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="transform -translate-y-4 opacity-0"
    enter-to-class="transform translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="transform translate-y-0 opacity-100"
    leave-to-class="transform -translate-y-4 opacity-0"
  >
    <div v-if="selectedService?.service_id" class="p-5 text-right">
      <p class="inline-block bg-gray-200 rounded-[8px] p-4 font-medium m-0">
        <span class="block text-[16px] mb-1">{{ selectedService.name }}</span>
        <span class="block text-[14px] font-light"
          >{{ getPrice(selectedService.price) }}
          <b class="ml-1.5 font-medium">{{
            showDurationUnit(
              selectedService.duration,
              selectedService.duration_unit
            )
          }}</b></span
        >
      </p>
    </div>
  </Transition>
</template>

<style scoped>
.add-service {
  border: 2px solid #fff;
}
.active,
.active:hover {
  background-color: #1e2939 !important;
  border-color: #1e2939 !important;
  color: #fff;
}
.active p {
  color: #fff !important;
}
.active .add-service {
  display: none !important;
}
</style>
